import { Suspense } from 'react';
import Linkify from 'react-linkify';

import FileAttachment from '../FileAttachment/FileAttachment';
import * as Style from './style';

function Link(decoratedHref, decoratedText, key) {
  return (
    <a key={key} target="_blank" rel="noopener noreferrer" href={decoratedHref}>
      {decoratedText}
    </a>
  );
}

function Message({
  message,
  color,
  isActiveUser,
  sameAuthorAsPrevious,
}) {
  const isSystem = !message.author;
  const dateTime = message.date.toISOString().slice(0, 19).replace('T', ' ');

  return (
    <Style.Item
      isSystem={isSystem}
      isActiveUser={isActiveUser}
      sameAuthorAsPrevious={sameAuthorAsPrevious}
    >
      <Style.Bubble isSystem={isSystem} isActiveUser={isActiveUser}>
        <Style.Index isSystem={isSystem} isActiveUser={isActiveUser}>
          {(message.index + 1).toLocaleString('de-CH')}
        </Style.Index>
        <Style.Wrapper>
          {!isSystem && !sameAuthorAsPrevious && (
            <Style.Author color={color}>{message.author}</Style.Author>
          )}
          {message.attachment ? (
            <Suspense fallback={`Loading ${message.attachment.fileName}...`}>
              <FileAttachment fileName={message.attachment.fileName} />
            </Suspense>
          ) : (
            <Linkify componentDecorator={Link}>
              <Style.Message>{message.message}</Style.Message>
            </Linkify>
          )}
        </Style.Wrapper>
        {!isSystem && (
          <Style.Date dateTime={dateTime}>
            {new Intl.DateTimeFormat('default', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            }).format(message.date)}
          </Style.Date>
        )}
      </Style.Bubble>
    </Style.Item>
  );
}

export default Message;
